const wallOfFame = [
  { name: "T. Sai Kushal", achievement: "U-14 Netball Nationals — Silver Medal" },
  { name: "Abhinav", achievement: "U-17 — Selected for Nationals" },
  { name: "Shravan", achievement: "U-14 Netball — Selected for Nationals" },
  { name: "Pradyumna", achievement: "U-17 Karate — Gold Medal (District)" },
  { name: "Gunapreeth", achievement: "U-14 Shooting — Bronze Medal (District); U-16 Throwball — Gold Medal (District)" },
  { name: "Rishik", achievement: "Taekwondo U-17 — Silver Medal (SGF)" },
  { name: "Rithvik", achievement: "Taekwondo U-17 — Silver Medal (SFA)" },
  { name: "Praneeth", achievement: "Taekwondo U-17 — Bronze Medal (SFA)" },
  { name: "Ansh", achievement: "Taekwondo U-17 — Bronze Medal" },
  { name: "Ahmed", achievement: "Taekwondo U-14 — Bronze Medal" },
  { name: "Gouri", achievement: "Taekwondo U-12 — Bronze Medal (SFA)" },
  { name: "Aaradhana", achievement: "Chess U-10 — Gold Medal" },
];

export default wallOfFame;